const ClientEventTypeList_query = `
    query( $clientId: Int!)
    {
      clientEventTypeList(clientId:$clientId)
      {
          eventTypeId
          clientId
          {
            clientId
            name            
          }
          name
          desc
          deletable
          createDate
          updateDate
          
      }
    }
`;

const LatestClientEventTypeByUpdateDate_query = `
    query( $clientId: Int!)
    {
      latestClientEventTypeByUpdateDate(clientId:$clientId)
      {
          eventTypeId
          clientId
          {
            clientId
            name            
          }
          name
          desc
          deletable
          createDate
          updateDate
          
      }
    }
`;

const CreateEventType_mutate = `
    mutation createEventType(
      $name: String!
      $clientId: Int!
      $desc: String            
      ) {
      createEventType(
        name: $name,
        clientId: $clientId
        desc: $desc
        ) {
        eventType
          {
            eventTypeId
            name
            desc
            clientId            
            {
              name
            }
            createBy
            createDate
            updateBy
            updateDate
          }
      }
    }
`;

const EditEventType_mutate = `
    mutation EditEventType(
      $eventTypeId: Int!
      $name: String!      
      $desc: String            
      ) {
      editEventType(
        eventTypeId: $eventTypeId,
        name: $name,        
        desc: $desc
        ) {
        eventType
          {
            eventTypeId
            name
            desc
            deletable
            clientId            
            {
              name
            }
            createBy
            createDate
            updateBy
            updateDate
          }
      }
    }
`;

const DeleteEventType_mutate = `
    mutation delete_eventType($eventTypeId: Int!) {
      deleteEventType(eventTypeId: $eventTypeId) {
        response
      }
    }
`;

const GetEventTypeIdByName_query = `
  query( $name: String!)
    {
      getEventTypeIdByName(name:$name)
      {
          eventTypeId
          clientId
          {
            clientId
            name            
          }
          name
          desc
          createDate
          updateDate
          
      }
    }  
`;

module.exports = {
  CLIENT_EVENT_TYPE_LIST_QUERY: ClientEventTypeList_query,
  LATEST_CLIENT_EVENT_TYPE_BY_UPDATE_DATE_QUERY: LatestClientEventTypeByUpdateDate_query,
  CREATE_EVENT_TYPE_MUTATION: CreateEventType_mutate,
  EDIT_EVENT_TYPE_MUTATION: EditEventType_mutate,
  DELETE_EVENT_TYPE_MUTATION: DeleteEventType_mutate,
  GET_EVENT_TYPE_ID_BY_NAME: GetEventTypeIdByName_query,
};
